import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=0a655d1e&scoped=true"
import script from "./plan.vue?vue&type=script&lang=js"
export * from "./plan.vue?vue&type=script&lang=js"
import style0 from "./plan.vue?vue&type=style&index=0&id=0a655d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a655d1e",
  null
  
)

export default component.exports